<template>
  <div :class="{ mobile: isMobile }">
    <h1>H1 Titel {{ sizes.h1 }} px Univers LT Pro Light.</h1>
    <h2>H2 Titel {{ sizes.h2 }} px Univers LT Pro Light.</h2>
    <h3>H3 Titel / Spitzmarken {{ sizes.h3 }} px univers lt pro Bold</h3>
    <p>
      Lauftext {{ sizes.body }} px Univers LT Pro Light – Lorem ipsum dolor sit
      amet, consectetur adipiscing elit. Quisque congue odio lorem, sit amet
      eleifend urna pulvinar at. Nunc justo dui, ornare ac purus sed, aliquam
      sodales sapien.
    </p>
    <p class="hfh-text-small">
      Kleintext {{ sizes.small }} px Univers LT Pro Light – Lorem ipsum dolor
      sit amet, consectetur adipiscing elit. Quisque congue odio lorem, sit amet
      eleifend urna pulvinar at. Nunc justo dui, ornare ac purus sed, aliquam
      sodales sapien. Morbi interdum vulputate urna, ut ullamcorper lectus
      maximus at. Donec volutpat ante ex, vel tempus augue sodales at.
    </p>
  </div>
</template>

<script setup>
import { computed } from "vue";
const props = defineProps({
  isMobile: Boolean,
});

const sizes = computed(() => {
  return {
    h1: props.isMobile ? 24 : 48,
    h2: props.isMobile ? 24 : 32,
    h3: props.isMobile ? 12 : 16,
    body: props.isMobile ? 18 : 20,
    small: props.isMobile ? 14 : 16,
  };
});
</script>

<style lang="scss" scoped>
div {
  display: flex;
  flex-direction: column;
  row-gap: 48px;

  h1 {
    font-size: 3rem;
  }
  h2 {
    font-size: 2rem;
  }
  h3 {
    font-size: 1rem;
  }
  font-size: 1.25rem;
  .hfh-text-small {
    font-size: 1rem;
  }

  &.mobile {
    h1 {
      font-size: 1.5rem;
    }
    h2 {
      font-size: 1.5rem;
    }
    h3 {
      font-size: 0.75rem;
    }
    font-size: 1.125rem;
    .hfh-text-small {
      font-size: 0.875rem;
    }
  }
}
</style>

